import { trackEvent } from 'services/analytics'

export const openLockedContentModal = (setModal, item = {}) => {
  trackEvent('locked_content_click', {
    portal: 'essentials',
    content_type: item?.uid || item?.type || 'unknown',
  })
  setModal({ type: 'exclusive-content' })
}

export const isContentLockedError = result => (
  result?.error?.details?.code === 'CONTENT_LOCKED'
  || result?.details?.code === 'CONTENT_LOCKED'
)
